import { mapGetters } from 'vuex';
import { TemplateActions } from '../../store/actions';
import { TemplateGetters } from '../../store/getters';
import { Permissions } from '../../enums/permissionsEnum';
import ConfirmDialog from '../../components/core/dialogs/confirmDialog';

export default {
	computed: {
		...mapGetters({
			templateFields: [TemplateGetters.TEMPLATE_FIELDS],
			loading: [TemplateGetters.LOADING_FIELDS],
		}),
		canAddTemplateFields() {
			return this.hasPermissions([
				Permissions.Tools.DataImport.Templates.TemplateFields.Add,
			]);
		},
		canViewTemplateFields() {
			return this.hasPermissions([
				Permissions.Tools.DataImport.Templates.TemplateFields.View,
			]);
		},
		canEditTemplateFields() {
			return this.hasPermissions([
				Permissions.Tools.DataImport.Templates.TemplateFields.Edit,
			]);
		},
		canDeleteTemplateFields() {
			return this.hasPermissions([
				Permissions.Tools.DataImport.Templates.TemplateFields.Delete,
			]);
		},
	},
	data() {
		return {
			headers: [
				{ text: '', sortable: false, value: 'Draggable', width: 10 },
				{ text: 'Order', sortable: false, value: 'Order' },
				{ text: 'Spreadsheet Field', sortable: false, value: 'Label' },
				{ text: 'Iris Field', sortable: false, value: 'DataFieldName' },
				{ text: 'Merge', sortable: false, value: 'IsMergeField' },
				{ text: 'Link Field', sortable: false, value: 'LinkFieldId' },
				{
					text: 'Reference Field',
					sortable: false,
					value: 'ReferenceListTypeId',
				},
				{ text: 'Confirmed', sortable: false, value: 'Confirmed' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
			selectedTemplateField: null,
		};
	},
	methods: {
		getRowCssClass(item) {
			if (item && item.Confirmed && item.GridViewField) return '';
			if (item && item.GridViewField && !item.Confirmed)
				return 'rowYellow';
			return 'rowRed';
		},

		onEditTemplateField(item) {
			this.selectedTemplateField = item;
			this.showTemplateFieldModal = true;
		},

		onDeleteTemplateFields(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this Grid Field?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(
					TemplateActions.DELETE_TEMPLATE_FIELD,
					item
				);
			});
		},
		addTemplateField() {
			this.showTemplateFieldModal = true;
		},

		closeTemplateFieldModal() {
			this.selectedTemplateField = null;
			this.showTemplateFieldModal = false;
		},

		onConfirmGridViewField(item) {
			item.Confirmed = true;
			this.$store
				.dispatch(TemplateActions.UPDATE_TEMPLATE_FIELD, item)
				.then((success) => {
					if (!success) item.Confirmed = false;
				});
		},
	},
};
